import { Typography } from "@mui/material";
import styled from "styled-components";

interface IStyledTypography {
    variant?:
        | "h1"
        | "h2"
        | "h3"
        | "h4"
        | "h5"
        | "h6"
        | "subtitle1"
        | "subtitle2"
        | "body1"
        | "body2"
        | "caption"
        | "overline";
    color?:
        | "primary"
        | "secondary"
        | "textPrimary"
        | "textSecondary"
        | "error"
        | "warning"
        | "info"
        | "success";
    fontWeight?: "normal" | "bold" | number;
}

const StyledTypography = styled(Typography)<IStyledTypography>`
    color: ${(props) => {
        switch (props.color) {
            case "primary":
                return props.theme.tableHeadCellBackground + " !important";
            case "secondary":
                return props.theme.pageSubTitleText + " !important";
            case "textSecondary":
                return props.theme.pageSubTitleText + " !important";
            case "error":
                return props.theme.accentButtonBackground + " !important";
            case "warning":
                return props.theme.labelWarningBg + " !important";
            case "info":
                return props.theme.labelPrimaryBg + " !important";
            case "success":
                return props.theme.labelSuccessBg + " !important";
            default:
                return "inherit";
        }
    }};
    font-family: Calibri !important;
    font-weight: ${(props) => props.fontWeight || "normal"};
`;

export default StyledTypography;
